import { proxy } from 'valtio'

const CustomizerContext = proxy({

    ui : false,
    mobileUi : false,
  
    chair : {
      color: 'M_Black',
      pattern : 'Chair_Heart'
    },
    pillow : {
      fabric : 'M_Fabric_flower',
      visible : false
    }
  
  }) 


export default CustomizerContext
